// extracted by mini-css-extract-plugin
export default {"skeletonImage":"ftDfH","skeletonPrice":"Ky9di","skeletonBrand":"h5CSc","loading":"MsCA3","skeletonTile":"Hdr6o"};